import { AfterContentInit, Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AreaTecnica } from "src/app/models/area.tecnica.model";
import { CentroCusto } from "src/app/models/centrocusto.model";
import { Empreiteira } from "src/app/models/empreiteira.model";
import { SpvDetalhes } from "src/app/models/spvDetalhes.model";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { AreaTecnicaService } from "src/app/pages/cadastros/areatecnica/areatecnica.service";
import { EmpreiteiraService } from "src/app/pages/cadastros/empreiteira/empreiteira.service";
import { FabricantedeService } from "src/app/pages/cadastros/services/fabricante.service";
import { CentroCustoService } from "src/app/services/centro.custo.service";
import { ClasseEquipamentoService } from "src/app/services/classe-equipamento.service";
import { EquipamentoService } from "src/app/services/equipamento.service";
import { GrupoLocalNivelService } from "src/app/services/grupo-local-nivel.service";
import { LocalService } from "src/app/services/local.service";
import { OSService } from "src/app/services/os-service";
import { SpvService } from "src/app/services/spv.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { APP_SETTINGS } from "src/environments/environment";
import { PrioridadeService } from "../../../services/prioridade.service";
import {
  ClasseEquipamento,
  GrupoLocalNivel1,
  Prioridade,
} from "../../domain/domain.model";
import {
  EquipamentoComboBoxViewModel,
  FotoBase64ViewModel,
} from "../../domain/viewmodels.models";
import { FecharOSService } from "../../os/fechar-os/fechar-os.service";
import { Photo } from "../../os/fechar-os/photo.model";
import { UploadPhoto } from "../../os/fechar-os/upload-photo.model";

@Component({
  selector: "app-avaliar-ss",
  templateUrl: "./avaliar-ss.component.html",
  styleUrls: ["./avaliar-ss.component.scss"],
  providers: [
    SpvService,
    AreaTecnicaService,
    EquipamentoService,
    EmpreiteiraService,
    LocalService,
    CentroCustoService,
    FabricantedeService,
  ],
})
export class AvaliarSSComponent implements OnInit, AfterContentInit {
  constructor(
    private spvService: SpvService,
    private areaTecnicaService: AreaTecnicaService,
    private equipamentoService: EquipamentoService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private empreiteiraService: EmpreiteiraService,
    private localService: LocalService,
    private centroCustoService: CentroCustoService,
    private fabricanteService: FabricantedeService,
    private usuarioService: UsuarioService,
    private grupoLocalNivelService: GrupoLocalNivelService,
    private classeEquipamentoService: ClasseEquipamentoService,
    private prioridadeService: PrioridadeService,
    private fechamentoOSService: FecharOSService,
    private osService: OSService,
  ) {
    this.iniciando = true;
  }

  iniciando = true;
  listaSpvsAbertas: SpvDetalhes[] = undefined;
  spvSelecionada: SpvDetalhes = null;
  spvId = 0;
  voids: string[] = [];
  maximoLinhas = 10;
  empreiteiras: Empreiteira[] = [];
  areaRestrita = false;
  buscandoEquipamentos = false;
  prioridades: Prioridade[] = [];
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  // Combo box

  areasTecnicas: AreaTecnica[] = [];
  equipamentos: EquipamentoComboBoxViewModel[] = []; // Equipamento para ComboBox
  centrosDeCusto: CentroCusto[] = [];
  fabricantes: any[] = [];

  formEquipamento: FormGroup = null;
  formFabricante: FormGroup = null;
  formAreaTecnica: FormGroup = null;
  formLocal: FormGroup = null;

  formAprovar: FormGroup = null;

  formRecusar = this.formBuilder.group({
    justificativa: new FormControl("", [
      Validators.required,
      Validators.minLength(1),
    ]),
  });

  autorizacoes: UsuarioAutorizacoes;

  public niveis1: GrupoLocalNivel1[] = [];
  public locaisPorNivel: any[] = [];

  public classesEquipamento: ClasseEquipamento[] = [];

  previewsPhotos: Photo[] = []; // armazena as photos em base 64 para exibição
  previewPhotoSelecionada: Photo; // dataUrl (base 64) da foto clicada
  uploadPhotos: UploadPhoto[] = [];

  autorizacaoAdicionarFoto: boolean;

  isProcessing: boolean = false;
  statusSS: string = "aberto";

  tipoOSFixas: any[] = [];
  tipoOSAdicionais: any[] = [];

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("avaliar-spv");
    this.autorizacaoAdicionarFoto =
      this.usuarioService.getAutorizacoesEspecificaPorRota(
        "ss-pt-programar-servico",
        "adicionar-fotos-antes",
      );
  }

  ngOnInit() {
    this.resetFormEquipamento();
    this.resetFormAreaTecnica();
    this.resetFormAprovarSpv();
    this.resetFormLocal();
    this.getFabricantes();
    this.getAllGrupoLocalNivel1();
    this.getClassesEquipamentos();
    this.getPrioridades();

    this.getSpvsAbertos();
    this.getTiposOSs();

    this.areaTecnicaService.getAreasTecnicas().subscribe(
      (response) => {
        this.areasTecnicas = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Areas Técnicas");
      },
    );

    this.centroCustoService.getCentrosCustos().subscribe(
      (response: CentroCusto[]) => {
        this.centrosDeCusto = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter lista de Centros Custos");
      },
    );

    this.empreiteiraService.getEmpreiteiras().subscribe((response) => {
      this.empreiteiras = response;
      if (this.empreiteiras.length == 1) {
        this.formAprovar.get("empreiteiraId").setValue(this.empreiteiras[0].id);
      }
    });

    this.iniciando = false;
  }

  getTiposOSs() {
    this.osService.GetTiposOSs().subscribe((response: any[]) => {
      if (response) {
        this.tipoOSFixas = response.filter((x) => x.tipo === "F");
        this.tipoOSAdicionais = response.filter((x) => x.tipo === "A");
      }
    });
  }

  private getPrioridades() {
    this.prioridadeService.getAll().subscribe((response: Prioridade[]) => {
      this.prioridades = response;
    });
  }

  private getClassesEquipamentos() {
    this.classeEquipamentoService
      .getAll()
      .subscribe((response: ClasseEquipamento[]) => {
        this.classesEquipamento = response;
      });
  }

  resetFormEquipamento() {
    this.formEquipamento = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl(null, Validators.required),
      numeroSerie: new FormControl(null, Validators.required),
      descricao: new FormControl(null, Validators.required),
      centroCustoId: new FormControl(null, Validators.required),
      localId: new FormControl("", Validators.required),
      tipoEquipamentoId: new FormControl(1),
      fabricanteId: new FormControl("", Validators.required),
      classeEquipamentoId: new FormControl("", Validators.required),
    });
  }

  resetFormAreaTecnica() {
    this.formAreaTecnica = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl(null, Validators.required),
    });
  }

  resetFormLocal() {
    this.formLocal = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl(null, Validators.required),
    });
  }

  resetFormFabricante() {
    this.formFabricante = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl(null, Validators.required),
    });
  }

  resetFormAprovarSpv() {
    this.formAprovar = this.formBuilder.group({
      servico: ["", Validators.required],
      localId: [""],
      tipoOS: [""],
      areaTecnicaId: [""],
      prioridadeId: [""],
      equipamentoId: [""],
      empreiteiraId: [""],
      areaRestrita: [false],
      observacoesGerais: [null],
      grupoLocalNivel1Id: [""],
    });

    if (this.empreiteiras.length == 1) {
      this.formAprovar.get("empreiteiraId").setValue(this.empreiteiras[0].id);
    }
  }

  getAllGrupoLocalNivel1() {
    this.grupoLocalNivelService
      .getAllGrupoLocalNivel1()
      .subscribe((response: GrupoLocalNivel1[]) => {
        this.niveis1 = response;
      });
  }

  changeGrupoLocalNivel1() {
    this.locaisPorNivel = [];

    const grupoLocalNivel1Id = Number(
      this.formAprovar.get("grupoLocalNivel1Id").value,
    );

    if (grupoLocalNivel1Id > 0) {
      this.localService
        .getLocaisByGroupLevelOne(grupoLocalNivel1Id)
        .subscribe((response) => {
          this.locaisPorNivel = response;

          if (this.locaisPorNivel.length == 1) {
            this.formAprovar.get("localId").setValue(this.locaisPorNivel[0].id);
            this.getEquipamentoPorLocalId(this.locaisPorNivel[0].id);
          }
        });
    }
  }

  getFabricantes() {
    this.fabricanteService.list().subscribe((response: any) => {
      this.fabricantes = response;
    });
  }

  getSpvsAbertos() {
    this.spvService.getSpvsAbertos().subscribe(
      (response) => {
        this.listaSpvsAbertas = response;
        this.setVoids();
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter SSs abertos");
      },
    );
  }

  getEquipamentoPorLocalId(id: number) {
    if (Number(id) === 0) {
      this.equipamentos = [];
      return;
    }

    this.buscandoEquipamentos = true;
    this.equipamentoService.getEquipamentosPorLocalId(id).subscribe(
      (response) => {
        this.equipamentos = response;
        this.buscandoEquipamentos = false;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Equipamentos");
        this.buscandoEquipamentos = false;
      },
    );
  }

  AprovarSubmit() {
    this.isProcessing = true;

    if (this.ValidFormAprovarSpv()) {
      this.spvService.getStatusSS(this.spvId).subscribe((statusSS: any) => {
        this.statusSS = statusSS.status;

        if (statusSS.status != "aberto") {
          this.getSpvsAbertos();
          this.isProcessing = false;
        } else {
          const spvAprovada = {
            tipoOs: this.formAprovar.get("tipoOS").value,
            prioridadeId: this.formAprovar.get("prioridadeId").value,
            areaTecnicaId: this.formAprovar.get("areaTecnicaId").value,
            localId: this.formAprovar.get("localId").value,
            equipamentoId: this.formAprovar.get("equipamentoId").value,
            ObservacoesGerais: this.formAprovar.get("observacoesGerais").value,
            spvId: this.spvId,
            servico: this.formAprovar.get("servico").value,
            empreiteiraId: this.formAprovar.get("empreiteiraId").value,
            areaRestrita: this.areaRestrita,
          };
          console.log(spvAprovada);
          this.spvService.aprovarSpv(spvAprovada).subscribe(
            (response: any) => {
              if (response.success) {
                this.getSpvsAbertos();
                this.modalService.dismissAll();
                this.toastr.success(response.message);
                this.resetFormAprovarSpv();
              } else {
                this.toastr.error(response.message);
              }

              this.isProcessing = false;
            },
            (err) => {
              if (err.error.errors) {
                this.toastr.error(err.error.errors[0].message);
              } else {
                this.toastr.error("Ocorreu um erro no servidor");
              }
              this.isProcessing = false;
            },
          );
        }
      });
    }
  }

  public ValidFormAprovarSpv() {
    let valid = true;

    if (this.formAprovar.get("localId").value === "") {
      this.formAprovar.get("localId").setErrors({ invalidLocalId: true });
      valid = false;
    }

    if (this.formAprovar.get("tipoOS").value === "") {
      this.formAprovar.get("tipoOS").setErrors({ invalidTipoOs: true });
      valid = false;
    }

    if (this.formAprovar.get("areaTecnicaId").value === "") {
      this.formAprovar
        .get("areaTecnicaId")
        .setErrors({ invalidAreaTecnicaId: true });
      valid = false;
    }

    if (this.formAprovar.get("prioridadeId").value === "") {
      this.formAprovar
        .get("prioridadeId")
        .setErrors({ invalidPrioridade: true });
      valid = false;
    }

    if (this.formAprovar.get("empreiteiraId").value === "") {
      this.formAprovar
        .get("empreiteiraId")
        .setErrors({ invalidEmpreiteiraId: true });
      valid = false;
    }
    return valid;
  }

  recusarSubmit() {
    this.spvService.getStatusSS(this.spvId).subscribe((statusSS: any) => {
      this.statusSS = statusSS.status;

      if (statusSS.status != "aberto") {
        this.getSpvsAbertos();
        this.isProcessing = false;
      } else {
        if (this.formRecusar.status === "INVALID") {
          this.formRecusar
            .get("justificativa")
            .markAsTouched({ onlySelf: true });
          this.toastr.error("A justificativa deve ser informada");
        } else {
          const spvRecusado = {
            justificativa: this.formRecusar.get("justificativa").value,
            spvId: this.spvId,
          };

          this.spvService.recusarSpv(spvRecusado).subscribe(
            (response: any) => {
              this.getSpvsAbertos();
              this.modalService.dismissAll();
              this.toastr.success(response.message);
              this.limparCampoReprovarSpv();
            },
            (err) => {
              if (err.error.errors) {
                this.toastr.error(err.error.errors[0].message);
              } else {
                this.toastr.error("Ocorreu um erro no servidor");
              }
            },
          );
        }
      }
    });
  }

  getById(id: number, modal) {
    this.equipamentos = [];
    this.formAprovar.reset();
    this.areaRestrita = false;

    this.previewsPhotos = [];
    this.previewPhotoSelecionada = null;
    this.uploadPhotos = [];
    this.statusSS = "aberto";

    this.spvService.getSpvDetalhes(id).subscribe(
      (response) => {
        this.spvSelecionada = response;

        this.resetFormAprovarSpv();
        this.formAprovar.get("servico").setValue(this.spvSelecionada.servico);

        if (this.niveis1.length === 1) {
          this.formAprovar
            .get("grupoLocalNivel1Id")
            .setValue(this.niveis1[0].id);
        } else {
          this.formAprovar.get("grupoLocalNivel1Id").setValue("");
        }

        this.changeGrupoLocalNivel1();
        this.modalService.open(modal, {
          windowClass: "xlModal",
          backdrop: "static",
        });
        this.spvId = id;

        this.uploadPhotos = response.uploadPhotos;

        this.fechamentoOSService
          .getArrayFotosBase64(this.uploadPhotos)
          .subscribe((responseFotos: FotoBase64ViewModel[]) => {
            responseFotos.forEach((foto) => {
              this.previewsPhotos.push({
                dataUrl: foto.base64String,
                name: foto.arquivoNome,
              });
            });
          });
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Spv Selecionada");
      },
    );
  }

  //AprovarSelecao() { this.limparCampoReprovarSpv(); }
  //ReprovarSelecao() { this.resetFormAprovarSpv();  }

  private limparCamposAprovarSpv() {
    this.formAprovar.get("localId").setValue("");
    this.formAprovar.get("tipoOS").setValue("");
    this.formAprovar.get("areaTecnicaId").setValue("");
    this.formAprovar.get("prioridadeId").setValue("");
    this.formAprovar.get("equipamentoId").setValue("");
    this.formAprovar.get("observacoesGerais").setValue(null);
    this.formAprovar.get("empreiteiraId").setValue("");
    this.formAprovar.get("areaRestrita").setValue("");

    this.formAprovar.get("localId").reset();
    this.formAprovar.get("tipoOS").reset();
    this.formAprovar.get("areaTecnicaId").reset();
    this.formAprovar.get("prioridadeId").reset();
    this.formAprovar.get("equipamentoId").reset();
    this.formAprovar.get("observacoesGerais").reset();

    this.formAprovar.get("empreiteiraId").reset();
    this.formAprovar.get("areaRestrita").reset();

    this.formAprovar.get("localId").markAsUntouched({ onlySelf: true });
    this.formAprovar.get("tipoOS").markAsUntouched({ onlySelf: true });
    this.formAprovar.get("areaTecnicaId").markAsUntouched({ onlySelf: true });
    this.formAprovar.get("prioridadeId").markAsUntouched({ onlySelf: true });
    this.formAprovar.get("equipamentoId").markAsUntouched({ onlySelf: true });
    this.formAprovar
      .get("ObservacoesGerais")
      .markAsUntouched({ onlySelf: true });
    this.formAprovar.get("empreiteiraId").markAsUntouched({ onlySelf: true });
    this.formAprovar.get("areaRestrita").markAsUntouched({ onlySelf: true });
  }

  private limparCampoReprovarSpv() {
    this.formRecusar.get("justificativa").setValue("");
    this.formRecusar.get("justificativa").reset();
  }

  private setVoids() {
    this.voids = [];

    if (this.listaSpvsAbertas.length < this.maximoLinhas) {
      for (let i = this.listaSpvsAbertas.length; i < this.maximoLinhas; i++) {
        this.voids.push("");
      }
    }
  }

  changeAreaRestrita(value: boolean) {
    this.areaRestrita = value;
  }

  openModalNovaAreaTecnica(modal) {
    this.resetFormAreaTecnica();
    this.modalService.open(modal, { windowClass: "sm", backdrop: "static" });
  }

  openModalCadastroEquipamento(localId: string, modal: any) {
    if (Number(localId) === 0) {
      this.toastr.warning(
        "Selecione um <b>Local</b> antes de cadastrar um novo <b>Equipamento</b>",
      );
      this.formAprovar.get("localId").setErrors({ invalidLocalId: true });
      return;
    }

    this.resetFormEquipamento();

    this.formEquipamento
      .get("centroCustoId")
      .setValue(this.spvSelecionada.centroCustoId);
    this.formEquipamento.get("localId").setValue(localId);

    this.modalService.open(modal, {
      windowClass: "lgModal",
      backdrop: "static",
    });
  }

  openModalCadastroFabricante(modal: any) {
    this.resetFormFabricante();
    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  novaAreaTecnica(c: any) {
    this.areaTecnicaService
      .isUniqueNomeAreaTecnica(this.formAreaTecnica.get("nome").value)
      .subscribe((isUniqueNomeAreaTecnica) => {
        if (isUniqueNomeAreaTecnica) {
          this.areaTecnicaService
            .setOutraAreaTecnica({
              nome: this.formAreaTecnica.get("nome").value,
            })
            .subscribe((objOutraareatecnica) => {
              if (Number(objOutraareatecnica.id) > 0) {
                this.areaTecnicaService.getAreasTecnicas().subscribe(
                  (response) => {
                    this.areasTecnicas = response;
                    this.toastr.success("Área Técnica cadastrada com sucesso");
                    this.formAprovar
                      .get("areaTecnicaId")
                      .setValue(Number(objOutraareatecnica.id));
                    c("Close click");
                  },
                  (err: any) => {
                    this.toastr.error("Erro ao tentar obter Areas Técnicas");
                  },
                );
              }
            });
        } else {
          this.formAreaTecnica.get("nome").setErrors({ notUnique: true });
        }
      });
  }

  addEquipamento(c) {
    this.equipamentoService
      .nomeJaCadastrado(this.formEquipamento.get("nome").value)
      .subscribe((isUniqueNomeEquipamento) => {
        if (isUniqueNomeEquipamento) {
          this.equipamentoService
            .numeroSerieJaCadastrada(
              this.formEquipamento.get("numeroSerie").value,
            )
            .subscribe((isUniqueNumeroSerieEquipamento) => {
              if (isUniqueNumeroSerieEquipamento) {
                this.equipamentoService
                  .post(this.formEquipamento.value)
                  .subscribe(
                    (retorno: any) => {
                      const id = retorno.data;

                      this.equipamentoService
                        .getEquipamentosPorLocalId(
                          this.formEquipamento.get("localId").value,
                        )
                        .subscribe(
                          (response: any) => {
                            this.equipamentos = response;
                            this.formAprovar
                              .get("equipamentoId")
                              .setValue(Number(id));
                            c("Close click");
                            this.toastr.success(retorno.message);
                          },
                          (err: any) => {
                            if (err.error.errors) {
                              this.toastr.error(err.error.errors[0].message);
                            } else {
                              this.toastr.error("Ocorreu um erro no servidor");
                            }
                          },
                        );
                    },
                    (err: any) => {
                      if (err.error.errors) {
                        this.toastr.error(err.error.errors[0].message);
                      } else {
                        this.toastr.error("Ocorreu um erro no servidor");
                      }
                    },
                  );
              } else {
                this.formEquipamento
                  .get("numeroSerie")
                  .setErrors({ notUniquens: true });
              }
            });
        } else {
          this.formEquipamento.get("nome").setErrors({ notUnique: true });
        }
      });
  }

  addFabricante(c) {
    this.fabricanteService
      .isUniqueNomeFabricante(this.formFabricante.get("nome").value)
      .subscribe((isUniqueNomeFabricante) => {
        if (isUniqueNomeFabricante) {
          this.fabricanteService.create(this.formFabricante.value).subscribe(
            (retorno: any) => {
              const id = retorno.data;

              this.fabricanteService.list().subscribe(
                (response: any) => {
                  this.fabricantes = response;
                  this.formEquipamento.get("fabricanteId").setValue(Number(id));
                  c("Close click");
                  this.toastr.success(retorno.message);
                },
                (err: any) => {
                  if (err.error.errors) {
                    this.toastr.error(err.error.errors[0].message);
                  } else {
                    this.toastr.error("Ocorreu um erro no servidor");
                  }
                },
              );
            },
            (err: any) => {
              if (err.error.errors) {
                this.toastr.error(err.error.errors[0].message);
              } else {
                this.toastr.error("Ocorreu um erro no servidor");
              }
            },
          );
        } else {
          this.formFabricante.get("nome").setErrors({ notUnique: true });
        }
      });
  }

  openModalExibePhoto(modal, pview) {
    this.previewPhotoSelecionada = pview;
    this.modalService.open(modal, {
      windowClass: "zoomPhotoModal",
      backdrop: "static",
    });
  }
}
